import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  className?: string;
  opacity?: string;
}
const ButcherPaper = ({ className }: Props) => {
  return (
    <div
      className={classNames(
        'tw-absolute tw-inset-0 tw-pointer-events-none tw-bg-butcherPaperBackground tw-opacity-20',
        className,
      )}
    />
  );
};

export default ButcherPaper;
